import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { Input, Button } from '@nazka/nazka.mapframe.components';

import PasswordInput from '@App/components/PasswordInput/PasswordInput';
import { resetPassword } from '@services/auth.service';
import PasswordTooltip from '@App/components/PasswordTooltip/PasswordTooltip';

import { validatePassword } from '../login-modal.utils';

function ResetPassword({ email, goBack }) {
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState();
  const [repeatError, setRepeatError] = useState();

  const resetPasswordMutation = useMutation({
    mutationFn: async () => {
      await resetPassword(email, code, newPassword);
    },
  });

  if (resetPasswordMutation.isSuccess) {
    return (
      <div>
        <p className="login-modal__form__success">
          Je wachtwoord is succesvol gewijzigd. Je kan nu inloggen met je nieuwe wachtwoord.
        </p>
        <Button
          className="login-modal__submit-button"
          onClick={goBack}
        >
          Terug naar inloggen
        </Button>
      </div>
    );
  }

  return (
    <>
      <p className="login-modal__form__success">
        Een email met verificatiecode is verstuurd. Controleer je inbox en spamfolder.
      </p>
      <div className="login-modal__form">
        <label className={`login-modal__form__label${error ? ' login-modal__form__label--error' : ''}`}>
          <span className="login-modal__form__label__text">
            Verificatiecode
          </span>
          <Input
            className="login-modal__form__label__input"
            value={code}
            onInputChange={v => setCode(v.target.value)}
            placeholder="Code uit email"
          />
        </label>
        <label className={`login-modal__form__label${error ? ' login-modal__form__label--error' : ''}`}>
          <span className="login-modal__form__label__text">
            Nieuw wachtwoord
            <PasswordTooltip />
          </span>
          <PasswordInput
            className="login-modal__form__label__input"
            value={newPassword}
            onInputChange={value => setNewPassword(value)}
            placeholder="Wachtwoord"
          />
          {error && (
            <p className="login-modal__form__label__error">
              {error}
            </p>
          )}
        </label>
        <label className={`login-modal__form__label${repeatError ? ' login-modal__form__label--error' : ''}`}>
          <span className="login-modal__form__label__text">
            Bevestig wachtwoord
          </span>
          <PasswordInput
            className="login-modal__form__label__input"
            value={confirmPassword}
            onInputChange={value => setConfirmPassword(value)}
            placeholder="Herhaal wachtwoord"
          />
          {repeatError && (
            <p className="login-modal__form__label__error">
              {repeatError}
            </p>
          )}
        </label>
      </div>
      <Button
        className="login-modal__submit-button"
        onClick={async () => {
          const error = validatePassword(newPassword);

          if (error) {
            setError(error);
            setRepeatError(null);
          } else if (newPassword !== confirmPassword) {
            setError(null);
            setRepeatError('Wachtwoorden komen niet overeen.');
          } else {
            setError(null);
            setRepeatError(null);

            resetPasswordMutation.mutate();
          }
        }}
        isLoading={resetPasswordMutation.isPending}
      >
        Nieuw wachtwoord instellen
      </Button>
    </>
  );
}

export default ResetPassword;
